import { render, staticRenderFns } from "./ModalMemorialAditivo.vue?vue&type=template&id=46d33244&scoped=true&"
import script from "./ModalMemorialAditivo.vue?vue&type=script&lang=js&"
export * from "./ModalMemorialAditivo.vue?vue&type=script&lang=js&"
import style0 from "./ModalMemorialAditivo.vue?vue&type=style&index=0&id=46d33244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d33244",
  null
  
)

export default component.exports